import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commentFormat',
    pure: true,
    standalone: false
})
export class CommentFormatPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): string {
    return value ? value.replace(/\n/g, '<br>') : '';
  }
}